module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar4-week-7f797992.svg";